import { useUserDataStore } from '~/stores' // Importe seu store de usuário aqui
import { getActivePinia } from 'pinia'
/* export default async function () {
  // Use Pinia store
  const userStore = useUserDataStore()

  // Use Nuxt app

  console.log(userStore.user)

  // Check if user exists
  if (!userStore.user) {
    // If user does not exist, redirect to login page
    console.log(userStore.user)
    //$router.push('/login')
  }

} */

export default  defineNuxtRouteMiddleware((to, from) => {
  const userStore = useUserDataStore();
  // since userStore only exist in client. ignore server side
  if (process.server) {
      return
  }

  const loggedRoutes = ['/login', '/auth/recuperar-senha', '/auth/criar-conta']
  const blockRoutes = ['/perfil/ingressos', '/v/checkout/*', '/perfil/favoritos', '/perfil', '/perfil/suporte', '/perfil/pedidos', '/perfil/pedidos/', '/perfil/editar']

  if (userStore.user) {
    if (userStore.profileComplete === false && !to.path.startsWith('/auth/')) {
      return navigateTo('/auth/completar-cadastro')
    }

    if (loggedRoutes.includes(to.path)) {
     return navigateTo('/perfil')
    }

  } else {

    const ret = to.path.replaceAll('/', '@d@')

    for (const blockedRoute of blockRoutes) {
      const regex = new RegExp(`^${blockedRoute.replace('*', '.*')}$`);
      if (regex.test(to.path)) {
        return navigateTo('/login?ret='+ret)
      }
    }
  }

/*   if (to.path !== "/login") {
      return navigateTo('/login')
  } */
})
/*
export default defineNuxtRouteMiddleware((to, from) => {
  const userStore = useUserDataStore(app.$pinia)
  const ge  = getActivePinia()


  console.log(ge)
  console.log(userStore.user)



  const unloggedRoutes = ['/login', '/recuperar-senha', '/criar-conta']
  const blockRoutes = ['/perfil/ingressos', '/perfil/favoritos', '/perfil', '/perfil/suporte', '/perfil/pedidos', '/perfil/pedidos/', '/perfil/editar']

if(ge){


  if (userStore.user) {

    if (unloggedRoutes.includes(to.path)) {
     return navigateTo('/perfil')
      console.log('LOGADO')
    }

  } else {


    if (blockRoutes.includes(to.path)) {
     return navigateTo('/login')
     console.log('DESLOGADO')

    }
  }
}

}) */
